import React from 'react'

import { ActivityStatus } from '../../../../components'
import CommonTypesBaseView from './CommonTypesBaseView'

const columns = [
  {
    id: 'name',
    label: 'Name',
    sortable: true
  },
  {
    id: 'is_active',
    label: 'Active',
    sortable: true,
    cellRenderer: (datum) => <ActivityStatus active={Boolean(datum)} />
  }
]

function OrganizationTypesView() {
  return (
    <CommonTypesBaseView
      title="Organization Types"
      category="Organization Types"
      columns={columns}
    />
  )
}

export default OrganizationTypesView
